import React from 'react';
import { Typography } from '@mui/material';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../css/style.css";

const Experience = () => {
    return (
        <section className="experience" id="experience">
            <Typography variant="h4" gutterBottom align="center">
                <FontAwesomeIcon icon={faBriefcase} size="sx" /> Experience
            </Typography>

            <div className="timeline">
        
                <div className="container left">
                    <div className="content">
                        <div className="tag">
                            <h4>Software Engineer</h4>
                        </div>
                        <div className="desc">
                            <h5>PayPal, MA</h5>
                            <h6>Jul 2022 – Current</h6>
                        </div>
                    </div>
                </div>

                <div className="container right">
                    <div className="content">
                        <div className="tag">
                            <h4>Software Engineer</h4>
                        </div>
                        <div className="desc">
                            <h5>Accenture, India</h5>
                            <h6>May 2019 – Aug 2021</h6>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default Experience;
